<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-10 col-lg-8 col-xl-6 mx-auto pt-3">

        <div v-if="!isActionSuccessful">
          <h1 class="text-center pb-3">{{ title }}</h1>
          <reset-password-form :id="id" :token="token" @actionSuccess="isActionSuccessful = true"></reset-password-form>
        </div>


        <div v-else class="text-center">
          <h2>{{ title }} was successful</h2>
          <b-button size="lg" variant="success" to="/login">Log in</b-button>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
import ResetPasswordForm from '../../components/forms/ResetPasswordForm'

export default {
  components: {
    resetPasswordForm: ResetPasswordForm,
  },
  props: ['id', 'token'],
  data() {
    return {
      isActionSuccessful: false,
    }
  },
  computed: {
    title: function() {
      return (this.id && this.token ? 'Set' : 'Reset') + ' Password'
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/pages/auth/ResetPassPage.vue